import { Box, SxProps, useTheme } from "@mui/material";
import { Link, Typography } from "@powerdiary/components-library/lib";

interface TermsAndConditionsLinkProps {
    setTermsAndConditionsVisibility: (newValue: boolean) => void;
    termsAndConditionsVisibility: boolean;
    wrapperSx?: SxProps;
}

export default function TermsAndConditionsLink({
    termsAndConditionsVisibility,
    setTermsAndConditionsVisibility,
    wrapperSx,
}: TermsAndConditionsLinkProps) {
    const theme = useTheme();
    return (
        <Box sx={wrapperSx} data-test-id="section_terms_and_conditions_link">
            <Typography variant="paragraphSmallRegular" color={theme.palette.text.secondary} textAlign="center">
                By proceeding you accept the
            </Typography>
            <Link
                variant="small"
                textAlign="center"
                onClick={() => setTermsAndConditionsVisibility(!termsAndConditionsVisibility)}
                aria-expanded={termsAndConditionsVisibility}
                aria-controls="terms-collapse-content"
                data-test-id="button_terms_and_conditions"
                marginTop="2px"
            >
                Terms & Conditions of use
            </Link>
        </Box>
    );
}
